import styled from 'styled-components';

import { colors, fonts } from '@gbs-monorepo-packages/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  gap: 0.5rem;
  & > button {
    height: 2.25rem;
  }
`;

export const Label = styled.span`
  font-family: ${fonts.admin};
  font-size: 1rem;
  text-align: center;
  color: ${colors.textLight};
`;


